import { createMemoryRouter, Outlet } from 'react-router-dom';

// Marketing Pages
import { LandingPage } from '@/features/marketing/pages/LandingPage/LandingPage.jsx';

// Auth Pages
import { OnboardingPage } from '@/features/auth/pages/OnboardingPage/OnboardingPage.jsx';
import { LoginPage } from '@/features/auth/pages/LoginPage/LoginPage.jsx';
import { SignupPage } from '@/features/auth/pages/SignupPage/SignupPage.jsx';

// Discovery Pages
import { DiscoveryPage } from '@/features/discovery/pages/DiscoveryPage/DiscoveryPage.jsx';

// Events Pages
import { EventsPage } from '@/features/events/pages/EventsPage/EventsPage.jsx';
import { EventDetailPage } from '@/features/events/pages/EventDetailPage/EventDetailPage.jsx';

// Venues Pages
import { VenuesPage } from '@/features/venues/pages/VenuesPage/VenuesPage.jsx';
import { VenueDetailPage } from '@/features/venues/pages/VenueDetailPage/VenueDetailPage.jsx';

// Social Pages
import { SocialPage } from '@/features/social/pages/SocialPage/SocialPage.jsx';

// Profile Pages
import { ProfilePage } from '@/features/profile/pages/ProfilePage/ProfilePage.jsx';
import { SettingsPage } from '@/features/profile/pages/SettingsPage/SettingsPage.jsx';

// Layout Components
import { AppShell } from './AppShell.jsx';

/**
 * Route Configuration
 * 
 * Uses createMemoryRouter for preview/build compatibility.
 * Routes are organized by feature for clear code boundaries.
 */
export const routes = [
  {
    path: '/',
    element: <AppShell />,
    children: [
      // Marketing
      { index: true, element: <LandingPage /> },
      
      // Auth
      { path: 'welcome', element: <OnboardingPage /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'signup', element: <SignupPage /> },
      
      // Discovery
      { path: 'discover', element: <DiscoveryPage /> },
      
      // Events
      { path: 'events', element: <EventsPage /> },
      { path: 'events/:id', element: <EventDetailPage /> },
      
      // Venues
      { path: 'venues', element: <VenuesPage /> },
      { path: 'venues/:id', element: <VenueDetailPage /> },
      
      // Social
      { path: 'social', element: <SocialPage /> },
      
      // Profile
      { path: 'profile', element: <ProfilePage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
];

/**
 * Memory Router for Static Build
 * 
 * createMemoryRouter is used for the static prototype build.
 * For production browser routing, swap to createBrowserRouter.
 */
export const router = createMemoryRouter(routes, {
  initialEntries: ['/'],
});

export default router;
